import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TestMessagesService } from './test-messages.service';

export const Ng1TestMessagesModule = angular
  .module('control-room.shared.services.test-messages', [])
  .factory('crTestMessagesService', downgradeInjectable(TestMessagesService));
